import { Fragment, useEffect, useRef, useState } from "react";
import { isValidArray, scrollToFocuse } from "../../../Layout/Common/common";

export const FeatureContainer = ({ htmlString, location }) => {
  const [featureData, setFeatureDate] = useState(null);
  const [position, setPosition] = useState(null);
  const [showReadMore, setShowReadMore] = useState(false);
  const divref = useRef();
  useEffect(() => {
    if (htmlString) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlString, "text/html");
      const arrayOfStrings = Array.from(doc.querySelectorAll("li"))
        .map((li) => li.textContent.trim())
        .filter((text) => text != "");
      setFeatureDate(arrayOfStrings);
    } else {
      setFeatureDate(null);
    }
  }, [htmlString]);

  useEffect(() => {
    setPosition(location);
    setTimeout(() => {
      if (location == "top" && divref.current && divref.current.offsetHeight > 450) {
        setShowReadMore(true);
      }
    }, 2000);
  }, [location]);

  const RenderFeatureList = ({ feature }) => {
    const clickToFcous = () => {
      const focusContainer = document.getElementById("section-descriptions");
      if (focusContainer) scrollToFocuse(focusContainer, 0, 200);
    };
    return (
      <Fragment>
        <div className="proSection-title featuresListing-right">
          <h4>Features</h4>
        </div>

        <div className={`prosection-features  ${showReadMore == true ? "text-container" : ""}`}>
          <ul className="productPage-content" ref={divref}>
            {feature.map((item, index) => (
              <li key={index}>
                <span>
                  <i className="fa-solid fa-circle" />
                </span>
                {item}
              </li>
            ))}
          </ul>
          {showReadMore == true && (
            <a href="#" onClick={clickToFcous} className="familyReadmore">
              Read More
            </a>
          )}
        </div>
      </Fragment>
    );
  };

  return (
    <Fragment>
      {isValidArray(featureData) && (
        <Fragment>
          {position && position == "top" ? (
            <RenderFeatureList feature={featureData} />
          ) : (
            <div className="productFeature">
              <RenderFeatureList feature={featureData} />
            </div>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};
